import { Dropdown, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import EToolTip from 'components/others/EToolTip';
import SolarIcon from 'components/icons/SolarIcon';

const STORAGE_KEY = 'objectDocuments.showDeleted';

export const readShowDeletedDocuments = (): boolean => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
        return false;
    }
};

export const writeShowDeletedDocuments = (showDeleted: boolean): void => {
    try {
        window.localStorage.setItem(STORAGE_KEY, showDeleted ? '1' : '0');
    } catch {
        // ignore quota / private mode
    }
};

interface DocumentsDeletedFilterProps {
    showDeleted: boolean;
    onChange: (showDeleted: boolean) => void;
}

const DocumentsDeletedFilter = ({ showDeleted, onChange }: DocumentsDeletedFilterProps) => {
    const { t } = useTranslation(['Objects']);

    return (
        <EToolTip title={t('documents.filter')}>
            <span className="d-inline-block">
                <Dropdown autoClose="outside">
                    <Dropdown.Toggle
                        className="fs-14 px-2"
                        size="sm"
                        variant={showDeleted ? 'danger' : 'primary'}
                        id="dropdown-object-documents-deleted"
                    >
                        <SolarIcon name="funnel" className="fs-14 p-0" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <div className="px-3 py-2" onClick={(event) => event.stopPropagation()}>
                            <Form.Check
                                type="checkbox"
                                id="object-documents-show-deleted"
                                className="mb-0 text-nowrap"
                                label={t('documents.showDeleted')}
                                checked={showDeleted}
                                onChange={(event) => onChange(event.target.checked)}
                            />
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
            </span>
        </EToolTip>
    );
};

export default DocumentsDeletedFilter;
